export default __webpack_public_path__ + "static/media/MenuExpandido.e7bea5c1.svg";